module.exports = __webpack_public_path__ + "static/media/3D.063ae1ca.svg";